import React, { useEffect, useRef } from 'react';
import { CheckboxField } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import styles from './CWCheckboxField.module.scss';
import messages from './ConfidentialityWaiver.messages';

export default function CWCheckboxField({
    id, onValueChange, showErrors, content, children, value, path, validationMessages
}) {
    const isSelected = value;
    const isError = validationMessages.length > 0 && showErrors;
    const translator = useTranslator();
    const getContainerClassname = () => {
        if (isSelected) return styles.cwCheckboxFieldContainerSelected;
        if (isError) return styles.cwCheckboxFieldContainerError;
        return styles.cwCheckboxFieldContainer;
    };
    const elem = useRef(null);
    useEffect(() => {
        if (!content) return;
        elem.current.innerHTML = content;
    }, []);
    return (
        <>
            <div className={getContainerClassname()}>
                <CheckboxField
                    id={id}
                    value={value}
                    onValueChange={(val) => {
                        onValueChange(val, path);
                    }}
                />
                <div ref={elem} className={styles.cwCheckboxFieldContent}>
                    {children}
                </div>
            </div>
            {isError && (
                <span
                    className={styles.cwCheckboxFieldErrorInfo}
                >
                    {translator(messages.consentMandatory)}
                </span>
            )}
        </>
    );
}
